const React = require('react');
const Modal = require('react-modal');
const customStyles = require('./utils/modal').customStyles;
const accountStatus = require('../enums/accountstatus');
const availabilityPageService = require('./services/availabilitypage').AvailabilityPageService;

const HoldAccount = React.createClass({
    getInitialState: function() {
        return {
            modalIsOpen: false,
            errorCode: 0
        };
    },

    contextTypes: {
        user: React.PropTypes.any
    },

    openModal: function() {
        this.setState({modalIsOpen: true, errorCode: 0});
    },

    closeModal: function() {
        this.setState({modalIsOpen: false, errorCode: 0});
    },

    holdAccount: function(event) {
        if (event)
            event.preventDefault();

        var _this = this;
        availabilityPageService.hold(this.props.ID, function(err) {
                if (!err) {
                    if (_this.props.onChange)
                        _this.props.onChange('AccountStatus', accountStatus.hold.value);
                    _this.closeModal();
                }
                else {
                    _this.setState({
                        errorCode: err
                    });
                }
        });
    },

    render: function() {
        return <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            style={customStyles}
            >

            <h2>Freeze Account</h2>

                <p>At times when you don't have availability, you can freeze your account.  Your future subscription fees will be suspended.
                    The public can still find and view your farm information,  but will not be able to see your availability.
                    Simply publish your availability to resume your subscription.
                    theFarmBoard may remove accounts that are frozen for more than 11 months.</p>
                    <a href="#" onClick={this.holdAccount} className="edit" style={{marginRight: 1 + "em"}} title="Freeze my Account">Freeze my Account</a>
                    <a href="#" onClick={this.closeModal} className="edit" title="Cancel">Cancel</a>
                {(this.state.errorCode === 500)?<p className="error">Your account cannot be frozen at this time.</p>:null}
        </Modal>;
    }

});

exports.HoldAccount = HoldAccount;